/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPMARITALSTATUS = {
    Married: 'M',
    Single: 'N',
    Divorced: 'D',
    Separated: 'S',
    Cohabitating: 'H',
    Widowed: 'W',
    CommonLaw: 'L',
    CivilPartnership: 'C',
    Unknown: 'U'
} as const;
export type IAPMARITALSTATUS = typeof IAPMARITALSTATUS[keyof typeof IAPMARITALSTATUS];


export function IAPMARITALSTATUSFromJSON(json: any): IAPMARITALSTATUS {
    return IAPMARITALSTATUSFromJSONTyped(json, false);
}

export function IAPMARITALSTATUSFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPMARITALSTATUS {
    return json as IAPMARITALSTATUS;
}

export function IAPMARITALSTATUSToJSON(value?: IAPMARITALSTATUS | null): any {
    return value as any;
}

